<template>
    <div class="collectpopup" v-if="dataVal.flag">
        <div class="collect">
            <div class="collect_head">
                <div class="collect_head_close"></div>
                <div class="collect_head_title">新增模型文件</div>
                <div class="collect_head_close" @click="handleRefund">
                    <i class="el-icon-close"></i>
                </div>
            </div>
            <div class="collect_info">
                <div class="collect_info_item">
                    <div class="collect_info_item_l">上传文件：</div>
                    <div class="collect_info_item_r3">
                        <el-upload class="upload-demo" accept=".ab" :action="uploadfile" :on-remove="handleRemove"
                            :limit="1" :before-upload="beforeAvatarSuccess" :on-success="handleAvatarSuccess"
                            :file-list="imageslist">
                            <el-button>点击上传</el-button>
                        </el-upload>
                    </div>
                </div>
            </div>
            <div class="collect_btn">
                <div class=" collect_btn_cancel" @click="handleRefund">取消</div>
                <div class="collect_btn_cancel collect_btn_submit" @click="handleSubmit">提交</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "modelUpload",
    props: ['dataVal'],
    data() {
        return {
            urls: localStorage.getItem('baseURL'),
            uploadfile: localStorage.getItem("baseURL") + "/api/admin/index/uploadfile",

            imageslist: [],
            headers: {
                token: localStorage.token,
            },
            imguploagsuccess: false,//是否处于上传图片中
        }
    },
    methods: {
        //取消弹窗
        handleRefund() {
            let data = {
                flag: false,
                submitFlag: false
            }
            this.imageslist = []
            this.$emit("modelupCal", data);
        },
        handleSubmit() {
            if (this.imguploagsuccess) {
                this.$message.warning("文件正在上传中，请稍后");
                return false
            }
            let obj = {
                flag: false,//弹窗是否显示
                submitFlag: true,//是否调用接口
                data: this.imageslist[0].response.data
            }
            this.$emit("modelupCal", obj);
        },
        handleRemove(file, fileList) {
        },
        // beforeAvatarUpload(file) {
        //     this.imguploagsuccess = true
        //     return true
        // },
        //图片上传
        handleAvatarSuccess(response, file, fileList) {
            this.imguploagsuccess = false
            if (response.code == 1) {
                fileList.forEach((element, i) => {
                    if (element.response && element.response.code == 0) {
                        fileList.splice(i, 1);
                    }
                });
                this.imageslist = fileList;
                this.imageslist[0].url = this.urls + response.data.file;

                this.$message({
                    type: "success",
                    message: "图片上传成功",
                });
            } else {
                fileList.forEach((element, i) => {
                    if (element.response && element.response.code == 0) {
                        fileList.splice(i, 1);
                    }
                });
                this.imageslist = fileList;
                this.$message({
                    type: "success",
                    message: response.msg,
                });
            }
        },
        beforeAvatarSuccess(file) {
            var img = file.name.substring(file.name.lastIndexOf(".") + 1);
            const suffix = (img === "ab" || img === "AB");
            if (!suffix) {
                this.$message.error("只能上传.ab文件！");
                return false;
            } else {
                this.imguploagsuccess = true
            }
            // if (!isLt35M) {
            //     this.$message.error("图片大小不能超过35MB");
            // }
            // return (suffix || suffix2 || suffix3) && isLt35M;
            return suffix;
        },
    }
}
</script>
<style lang="scss" scoped>
.collectpopup {
    width: 100vw;
    height: 100vh;
    background-color: rgba($color: #000000, $alpha: 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;

    .collect {
        min-width: 540px;
        background-color: #fff;
        border-radius: 16px;
        overflow: hidden;
        display: flex;
        flex-direction: column;

        .collect_head {
            width: 100%;
            height: 50px;
            background-color: #f6f6f6;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 20px;

            .collect_head_close {
                width: 20px;
                height: 20px;
                cursor: pointer;

                .el-icon-close {
                    font-size: 20px;
                    color: #999999;
                    cursor: pointer;
                }
            }

            .collect_head_title {
                font-size: 16px;
                color: #333333;
                cursor: default;
            }
        }

        .collect_info {
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: 0 37px 0 29px;
            margin-top: 10px;

            .collect_info_item {
                width: 100%;
                display: flex;
                margin-top: 20px;

                .collect_info_item_l {
                    min-width: 100px;
                    height: 32px;
                    line-height: 32px;
                    font-size: 14px;
                    letter-spacing: 1px;
                    color: #333333;
                    text-align: right;
                    padding-right: 10px;
                }

                .collect_info_item_r3 {
                    // background-color: #f9f9f9;
                    border-radius: 4px;
                    // border: solid 1px #dbdbdb;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                    z-index: 101;
                }
            }
        }

        .collect_btn {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding: 30px 37px 26px 37px;

            .collect_btn_cancel {
                width: 80px;
                height: 32px;
                font-size: 14px;
                color: #606266;
                background-color: #ffffff;
                border-radius: 4px;
                border: solid 1px #dbdbdb;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: 10px;
                cursor: pointer;
            }

            .collect_btn_submit {
                color: #ffffff;
                border: solid 1px #e64a19;
                background-color: #e64a19;
            }
        }
    }
}
</style>